import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DialogModule } from 'primeng/dialog';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { NgModule } from '@angular/core';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

const CommonModulesList: any[] = [
  DialogModule,
  NgSelectModule,
  CKEditorModule,
  ButtonModule,
  CheckboxModule,
  AutoCompleteModule,
  TooltipModule,
  OverlayPanelModule,
  DragDropModule,
  RadioButtonModule,
  CalendarModule,
  InputMaskModule,
  TableModule,
  NgxPermissionsModule,
  InputTextareaModule,
  ChipModule,
  ChipsModule,
  InputSwitchModule,
  ConfirmPopupModule,
];

@NgModule({
  declarations: [],
  imports: [...CommonModulesList],
  exports: [...CommonModulesList],
})
export class ContractPrimeNgModule {}
